var ItemModal = require('./ItemModal.view');

var ItemModalUpdate = ItemModal.extend({

    events: {
        'click .update': 'update',
        'keypress': 'keypress'
    },

    initialize(options) {
        this._super(options);
        this.isUpdating = true;
        this.title = 'Update Item';
        this.syncingText = 'Updating Item...';
        this.hiddenInputs.push('date_dependable');
        this.hiddenInputs.push('uses_amounts');
    },

    open(model) {
        this.original = model;
        this.model = this.original.clone();
        this.isSyncing = false;
        this.render();
        this.show();
    },

    bindModel() {
        this._super();
        if(this.original) {
            this.listenTo(this.original, 'request', () => { this.setSyncing(true) });
            this.listenTo(this.original, 'sync', this.onSync);
            this.listenTo(this.original, 'error', this.onError);
        }
    },

    unbindModel() {
        this._super();
        if(this.original) this.stopListening(this.original);
    },

    update() {
        this.model.validate();
        if(this.model.isValid()) {
            this.original.save(this.model.attributes, { wait: true });
        }
    },

    onSync() {
        this.trigger('update', this.original);
        this.unbindModel();
        this.hide();
    },

    keypress(e) {
        if(e.which == 13) {
            e.preventDefault();
            this.update();
        }
    }
});

module.exports = ItemModalUpdate;
